import React, { Component } from 'react'
import {TextArea} from 'semantic-ui-react'
import {Auth0Context} from './contexts/auth-context'
import Utils from "./modules/utils"
import $ from 'jquery'
import {textAreaStyle} from './components/edit-sales-order/Elements'

class LaFashionPdfPage extends Component {

  static contextType = Auth0Context

  constructor(props) {
    super(props)
    this.state = {
      results: []
    }
  }

  submit = () => {
    let styleNumber = $('#stylenumber').val()
    if (styleNumber.length < 5) return

    let data = {styleNumber}

    let hideUnitsUnder = $('#hide-units-under').val()
    if (hideUnitsUnder != '') {
      data['hideUnitsUnder'] = Number(hideUnitsUnder)
    }

    Utils.post('la_fashion_pdf', data, (err, res) => {
      if (err) {
        alert('There was an error when trying to get la fashion pdf.')
      } else {
        let {results} = this.state
        results.push(res.data.url)
        this.setState({results})
      }
    })
  }

  render() {
    let {results} = this.state

    return (
      <div style={{padding: '50px 60px', whiteSpace: 'nowrap'}}>
        <h1 style={{marginTop: '25px', marginBottom: '35px'}}>LA Fashion PDF</h1>
        <small style={{display: 'block', marginLeft: '80px'}}>Enter style number base</small>
        <TextArea id="stylenumber" placeholder="Enter style number base" style={textAreaStyle}/>
        &nbsp;&nbsp;
        <button style={{padding: '10px', cursor: 'pointer', width: '200px', marginLeft: '10px'}} onClick={this.submit}>Submit</button>
        <br/>
        <small style={{display: 'block', marginLeft: '80px', marginTop: '10px'}}>Enter min units</small>
        <input id="hide-units-under" placeholder="Enter min units" type="number" min="1" max="999999" step="1" style={{width: '150px', marginLeft: '80px'}}/>

        <br/>
        <br/>
        {
          results.length
          ?
          <div>
            Results:<br/>
            {results.reverse().map(row => <div><a href={row} target="_blank">{row}</a></div>)}
          </div>
          :
          null
        }
      </div>
    )
  }
}


export default LaFashionPdfPage
